import { useSelector } from "react-redux";
import { selectTravelers } from "store/quote/selectors";
import { Container, TravelersList, TravelerItem } from "./styles";
import { UserIcon } from "../styles";
import { useBreakpoint } from "hooks/use-breakpoint";

export function TravelersDropList({
  anchorEl,
  handleClose,
}: {
  anchorEl: HTMLElement | null;
  handleClose: () => void;
}) {
  const travelers = useSelector(selectTravelers);
  const mdBreakpoint = useBreakpoint("md");

  return (
    <Container
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      disableScrollLock
    >
      <TravelersList>
        {travelers.map(({ firstName, lastName }, index) => (
          <TravelerItem key={`${firstName} ${lastName}-${index}`}>
            {mdBreakpoint && <UserIcon />} {firstName} {lastName}
          </TravelerItem>
        ))}
      </TravelersList>
    </Container>
  );
}
